import "./style.css";
import React from "react";

const AnimatedDots: React.FC = () => (
  <div className="dot-typing" />
);

export default AnimatedDots;
